import { useLayoutEffect, useEffect } from 'react';

/**
 * Fix to prevent warning from NextJs about useLayoutEffect not working when rendered on the server
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
